import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";
import "./style.scss";
import LineWithDot from "../../../../../assets/images/Line wit Dot.svg";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";
import Pagination from "react-js-pagination";
import { Button as MaterialButton } from "@material-ui/core";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import { Country, State, City } from "country-state-city";
import profile from "../../../../../assets/svg/cohortMeetingCircle.svg";
import { getMentorCohortApplicationList } from "../../MentorDashboard/dependencies/action";
import CohortSummaryModal from "../../../../common/cohortSummaryModal";
import api from "../../../../common/dependencies/utils/Api";
import MentorshipSummaryModal from "../../../../common/mentorshipSummaryModal";
import excelButton from "../../../../../assets/images/maargThemeXls2.png";
import mentorIcon from "../../../../../assets/images/Icon_Mentor_White.svg";
import axios from "axios";
import {
  COHORT_NAME_LIST,
  COHORT_ADMIN_COUNTER,
  DOWNLOAD_EXCEL_TOTAL_COHORT_STARTUPS,
  DOWNLOAD_EXCEL_TOTAL_COHORT_MENTORS
} from "../../../../common/constants/ApplicationUrl";

// import {
//   getStartupApplication,
//   getCountersStartUpList,
// } from "../dependencies/action";
import { getPredefineOptionsList } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import * as moment from "moment";
import Modal from "../../StartupDashboard/MyRequests/Modal/modal";
import Select from "react-select";
import Button from "../../AdminDashboard/Button";
import mentorshipIcon2 from "../../../../../assets/svg/dashboard/view-Mentroships.svg";
import mentorshipIcon from "../../../../../assets/svg/cohortMeeting.svg";
import mentorshipIcon3 from "../../../../../assets/svg/startupMiniCircle.svg";
import mentorshipIcon4 from "../../../../../assets/svg/mentorsMiniCircle.svg";
import { getNamesList } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import {
  postMentorModuleCohort,
  postMentorModuleStartupCohort,
  getmatchTableList,
  cohortListTable,
} from "../../MentorDashboard/dependencies/action";
const ActivityCohortTotal = (props) => {
  const html = document.getElementsByTagName("html")[0];
  const {
    getNamesList,
    getNamesListData,
    getMentorCohortApplicationList,
    postMentorModuleCohort,
    cohortStartupData,
    cohortMentorData,
    postMentorModuleStartupCohort,
    getmatchTableList,
    cohortMatchMakingList,
    getStepperTooltipData,
    getStepperData,
  } = props;
  // const imageUrl = "https://uat-nmp-api.startupindia.gov.in/v1/document/;";
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const [activeText, setActiveText] = useState(false);
  const [activeText2, setActiveText2] = useState(false);
  const [activeText3, setActiveText3] = useState(false);
  const [activeText4, setActiveText4] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [selectedRow, setSelectedRow] = useState("");
  const LoginRole = JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
  const [mentorShipReqData, setMentorShipReqData] = useState();
  const [tableList, setTableList] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const history = useHistory();
  const [indexCounter, setIndexCounter] = useState(0);
  const [nameListValue, setNameListValue] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [filterNameValue, setFilterNameValue] = useState("");
  const [filterCohortname, setFilterCohortname] = useState("");
  const [filterCohortId, setFilterCohortId] = useState("");
  const [cohortnameList, setcohortnameList] = useState([]);
  const [cohortnameId, setcohortnameId] = useState([]);
  const [cohortfilterGo, setcohortfilterGo] = useState(false);
  const [cohortAdminCounter, setCohortAdminCounter] = useState({});
  const LoginUser = JSON.parse(localStorage.getItem("SavedLoggedInData"));

  const defaultFormData = {
    search: "",
    industry: null,
    specialization: null,
    stage: null,
    recognized: "",
    state: "",
    country: "",
  };

  const newCountryArray = [];
  const newStateArray = [];
  const [selectedStatus, setSelectedStatus] = useState("");
  const [formData, setFormData] = useState(defaultFormData);
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [newCountrySelect, setNewCountrySelect] = useState(false);
  const [allMentorNames, setAllMentorNames] = useState();
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [modalVisibility, setModalVisibility] = useState(false);
  const [modalVisibility2, setModalVisibility2] = useState(false);
  const [fromModule, setFromModule] = useState("");
  const [modalData, setModalData] = useState("");
  const [cohortModalData, setCohortModalData] = useState("");
  const [cohortModalMentorData, setCohortModalMentorData] = useState();
  const [cohortModalMentorData2, setCohortModalMentorData2] = useState();
  const [cohortModalStartupData, setCohortModalStartupData] = useState([]);
  const [isShown, setIsShown] = useState(false);
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };
  const {
    getStartupApplication,
    startUpApplication,
    startUpApplicationPagineate,
    getTableDataPaginate,
    getTableData,
    getCountersStartUpList,
    getCounterStartUp,
    getPredefineOptionsList,
    getPredefineOptions,
  } = props;
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  useEffect(() => {
    html.style.overflow = "auto";
    if (props?.location?.state?.requestStatus === undefined) {
      setActiveText(true);
    } else if (props?.location?.state?.requestStatus === "pending") {
      setActiveText2(true);
    } else if (props.location.state.requestStatus === "viewAll") {
      setActiveText(true);
    } else setActiveText(true);
  }, []);
  useEffect(() => {
    let params = {
      listKey: "Startup",
    };
    getNamesList(params);
  }, []);
  const getTableDataStatus2 = (status) => {
    setcohortfilterGo(!cohortfilterGo);
  };
  useEffect(() => {
    let nameArrList = [];

    getNamesListData?.forEach((element, index) => {
      if (index === 0) {
        let arr2 = {
          value: "Select",
          label: "Select Startup",
        };
        setNameListValue((oldArray) => [...oldArray, arr2]);
      }
      let arr = {
        value: element.id,
        label: element.name,
      };
      if (getNamesListData.length >= nameListValue.length)
        setNameListValue((oldArray) => [...oldArray, arr]);
    });
  }, [getNamesListData]);
  const getSummaryListName = (name) => {
    let params = {
      status: "NotLoggedIn",
      country: formData?.country?.value == null ? "" : formData?.country?.label,
      state:
        formData?.state?.value == "select" ||
        formData?.state == "" ||
        formData?.state == null
          ? ""
          : formData.state.value, // optional
      industry:
        formData?.industry?.value == "select" || formData?.industry == ""
          ? ""
          : formData?.industry?.value, // optional
      function:
        formData?.function?.value == "select" || formData?.function == ""
          ? ""
          : formData?.function?.value, // optional
      stage:
        formData?.stage?.value == "select" || formData?.stage == ""
          ? ""
          : formData?.stage?.value,
      mentorId: name == "Select" || name == undefined ? "" : name,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "name",
        sortOrder: "ASC",
      },
    };
    //   getActivitySummaryPerformance(params);
  };
  //   const getStartupApplicationTable = (status) => {
  //     setActivePage(1);
  //     let params = {
  //       requestedBy: "",
  //       status: status,
  //       pageFilter: {
  //         currentPage: 0,
  //         pageSize: 10,
  //         sortField: "id",
  //         sortOrder: "ASC",
  //       },
  //       searchField: filterNameValue == "Select" ? "" : filterNameValue,
  //       searchKey: null,
  //       country: "",
  //       // id: formData?.name?.value == "select" ? null : formData?.name?.value, // optional
  //       state: formData.state == "select" ? null : formData?.state?.value, // optional
  //       industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
  //       function: formData.function == "select" ? "" : formData?.function?.value, // optional
  //       stage: formData.stage == "select" ? "" : formData?.stage?.value,
  //       // country: "",
  //       // state: "",
  //       // industry: "", // optional
  //       // function: "", // optional
  //       // stage: "",
  //     };
  //     getStartupApplication(params);
  //   };
  //   const getStartUpListDataNameSearch = (name) => {
  //     let params = {
  //       requestedBy: "",
  //       status: "",
  //       pageFilter: {
  //         currentPage: 0,
  //         pageSize: 10,
  //         sortField: "id",
  //         sortOrder: "ASC",
  //       },
  //       searchField: name === "Select" ? "" : name,
  //       searchKey: null,
  //       status: selectedStatus,
  //       country: "",
  //       // id: formData?.name?.value == "select" ? null : formData?.name?.value, // optional
  //       state: formData.state == "select" ? null : formData?.state?.value, // optional
  //       industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
  //       function: formData.function == "select" ? "" : formData?.function?.value, // optional
  //       stage: formData.stage == "select" ? "" : formData?.stage?.value,
  //     };
  //     getStartupApplication(params);
  //   };
  useEffect(() => {
    if (LoginRole === "Mentor") {
      // axios({
      //   url: COHORT_NAME_LIST,
      //   method: "post",
      //   data: {
      //     mentorId:
      //       localStorage.getItem("SavedLoggedInData") &&
      //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      //     status: "VERIFIED",
      //   },
      // })
      api
        .POST(COHORT_NAME_LIST, {
          mentorId:
            localStorage.getItem("SavedLoggedInData") &&
            JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
          status: "VERIFIED",
        })
        .then((res) => {
          const cohortnameArray = [];

          // setCounterData(res.data?.data)
          res.data.data &&
            res.data.data.map((item, index) => {
              // const params = {
              //   label: item.name,
              //   value: item.id,
              // };
              // cohortnameArray.push(params);
              if (index === 0) {
                let arr2 = {
                  label: "Select Cohort Name",
                  value: "select",
                };
                setcohortnameList((oldArray) => [...oldArray, arr2]);
              }
              let arr = {
                label: item.name,
                value: item.id,
              };
              if (res.data.data.length >= cohortnameList.length)
                setcohortnameList((oldArray) => [...oldArray, arr]);
            });

          // setcohortnameList(cohortnameArray);
          // setcohortnameId(cohortidArray);
        })
        .catch((err) => {});

      // axios({
      //   url: COHORT_NAME_LIST,
      //   method: "post",
      //   data: {
      //     status: "VERIFIED",
      //     mentorId:
      //       localStorage.getItem("SavedLoggedInData") &&
      //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      //   },
      // })
      api
        .POST(COHORT_NAME_LIST, {
          status: "VERIFIED",
          mentorId:
            localStorage.getItem("SavedLoggedInData") &&
            JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        })
        .then((res) => {
          // const cohortnameArray = [];
          const cohortidArray = [];

          res.data.data &&
            res.data.data.map((item, index) => {
              // const params = {
              //   label: `C${item.id.slice(-6)}`,
              //   value: item.id,
              // };
              // cohortidArray.push(params);
              if (index === 0) {
                let arr2 = {
                  label: "Select Cohort Id",
                  value: "select",
                };
                setcohortnameId((oldArray) => [...oldArray, arr2]);
              }
              let arr = {
                label: `C${item.id.slice(-6)}`,
                value: item.id,
              };
              if (res.data.data.length >= cohortnameId.length)
                setcohortnameId((oldArray) => [...oldArray, arr]);
            });

          // setcohortnameList(cohortnameArray);
          // setcohortnameId(cohortidArray);
        })
        .catch((err) => {});

      // axios({
      //   url: COHORT_ADMIN_COUNTER,
      //   method: "post",
      //   data: {
      //     cohortAdminId:
      //       localStorage.getItem("SavedLoggedInData") &&
      //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      //   },
      // })
      api
        .POST(COHORT_ADMIN_COUNTER, {
          cohortAdminId:
            localStorage.getItem("SavedLoggedInData") &&
            JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        })
        .then((res) => {
          // const cohortnameArray = [];

          setCohortAdminCounter(res.data.data);
        })
        .catch((err) => {});
    } else {
      // axios({
      //   url: COHORT_NAME_LIST,
      //   method: "post",
      //   data: {
      //     // mentorId:
      //     //   localStorage.getItem("SavedLoggedInData") &&
      //     //   JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      //   },
      // })
      api
        .POST(COHORT_NAME_LIST, {status: "VERIFIED"
          // mentorId:
          //   localStorage.getItem("SavedLoggedInData") &&
          //   JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        })
        .then((res) => {
          const cohortnameArray = [];

          // setCounterData(res.data?.data)
          res.data.data &&
            res.data.data.map((item, index) => {
              if (index === 0) {
                let arr2 = {
                  label: "Select Cohort Name",
                  value: "select",
                };
                setcohortnameList((oldArray) => [...oldArray, arr2]);
              }
              // const params = {
              //   label: item.name,
              //   value: item.id,
              // };
              // cohortnameArray.push(params);

              if (item.name !== null && item.name !== "") {
                let arr = {
                  label: item.name,
                  value: item.id,
                };
                if (res.data.data.length >= cohortnameList.length)
                  setcohortnameList((oldArray) => [...oldArray, arr]);
              }
            });

          // setcohortnameList(cohortnameArray);
          // setcohortnameId(cohortidArray);
        })
        .catch((err) => {});

      // axios({
      //   url: COHORT_ADMIN_COUNTER,
      //   method: "post",
      //   data: {
      //     // cohortAdminId:
      //     //   localStorage.getItem("SavedLoggedInData") &&
      //     //   JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      //   },
      // })
      api
        .POST(COHORT_ADMIN_COUNTER, {
          // cohortAdminId:
          //   localStorage.getItem("SavedLoggedInData") &&
          //   JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        })
        .then((res) => {
          // const cohortnameArray = [];

          setCohortAdminCounter(res.data.data);
        })
        .catch((err) => {});

      // axios({
      //   url: COHORT_NAME_LIST,
      //   method: "post",
      //   data: {
      //     status: "VERIFIED",
      //     // mentorId:
      //     //   localStorage.getItem("SavedLoggedInData") &&
      //     //   JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      //   },
      // })
      api
        .POST(COHORT_NAME_LIST, {
          status: "VERIFIED",
          // mentorId:
          //   localStorage.getItem("SavedLoggedInData") &&
          //   JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        })
        .then((res) => {
          // const cohortnameArray = [];
          const cohortidArray = [];

          res.data.data &&
            res.data.data.map((item, index) => {
              // const params = {
              //   label: `C${item.id.slice(-6)}`,
              //   value: item.id,
              // };
              // cohortidArray.push(params);
              if (index === 0) {
                let arr2 = {
                  label: "Select Cohort Id",
                  value: "select",
                };
                setcohortnameId((oldArray) => [...oldArray, arr2]);
              }
              let arr = {
                label: `C${item.id.slice(-6)}`,
                value: item.id,
              };
              if (res.data.data.length >= cohortnameId.length)
                setcohortnameId((oldArray) => [...oldArray, arr]);
            });

          // setcohortnameList(cohortnameArray);
          // setcohortnameId(cohortidArray);
        })
        .catch((err) => {});
    }
    // getAllData()
  }, []);
  const approvalOptions = [
    {
      value: "Approve",
      label: "Approve",
    },
    { value: "Reject", label: "Reject" },
    { value: "Request Info", label: "Request Info" },
  ];
  const tempVar = {
    no: "1",
    name: "Sample Cohort",
    appID: "A21232",
    appDate: "29-08-2022",
    cohortID: "C14698",
    appStatus: "",
    comments: "Sample Comment",
    mentorEngaged: "10",
    startupEngaged: "12",
    mentorship: "0",
    sessionTotal: "0",
    sessionComplete: "0",
    sessionUpcoming: "0",
    hoursTotal: "0",
    hoursComplete: "0",
    hoursUpcoming: "0",
  };
  useEffect(() => {
    let params = {
      cohortId: filterCohortId == "select" ? "" : filterCohortId,
      cohortAdminId:
        LoginRole === "Mentor"
          ? JSON.parse(localStorage.getItem("SavedLoggedInData")).id
          : "",
      sortKey: "name",
      sortOrder: "ASC",
      country: null,
      state: null,
      industry:
        filterIndustry && filterIndustry == "select" ? "" : filterIndustry,
      function:
        filterFunction && filterFunction == "select" ? "" : filterFunction,
      stage: filterStage && filterStage == "select" ? "" : filterStage,
      searchField:
        LoginRole === "Mentor"
          ? JSON.parse(localStorage.getItem("SavedLoggedInData")).id
          : "",
      searchKey: null,
      status: "VERIFIED",
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "date_applied",
        sortOrder: "DESC",
      },
    };
    getMentorCohortApplicationList(params);
  }, [cohortfilterGo]);
  const newList = [];
  newList.push(tempVar);
  useEffect(() => {
    getPredefineOptionsList();
    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });
    State.getStatesOfCountry("IN").map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newStateArray.push(newObject);
      setNewStateOptions(newStateArray);
    });
  }, []);
  useEffect(() => {
    getStepperTooltipData();
  }, []);
  useEffect(() => {
    //
    //
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);

  //   useEffect(() => {
  //     let params = {
  //       requestedBy: "",
  //       status: "",
  //       pageFilter: {
  //         currentPage: 0,
  //         pageSize: 10,
  //         sortField: "id",
  //         sortOrder: "ASC",
  //       },
  //       searchField: null,
  //       searchKey: null,
  //       country: "",
  //       // id: formData?.name?.value == "select" ? null : formData?.name?.value, // optional
  //       state: formData.state == "select" ? null : formData?.state?.value, // optional
  //       industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
  //       function: formData.function == "select" ? "" : formData?.function?.value, // optional
  //       stage: formData.stage == "select" ? "" : formData?.stage?.value,
  //     };
  //     getStartupApplication(params);
  //   }, []);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: "15.5vw",
      whiteSpace: "nowrap",
    }),
    menu: (base) => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
      fontSize: "14px",
    }),
    option: (provided, state) => ({
      ...provided,

      textAlign: "left",
    }),
  };
  useEffect(() => {
    getPredefineOptionsList();
  }, []);
  //   useEffect(() => {
  //     if (
  //       history?.location?.state?.requestStatus === "viewAll" ||
  //       history?.location?.state?.requestStatus === undefined
  //     ) {
  //       getStartupApplicationTable("");
  //     } else {
  //       getStartupApplicationTable("PENDING");
  //     }
  //   }, []);
  const ViewApplicationCohort = (item) => {
    let reRoute = window.open(`/view-CohortApplication/${item}`, "_blank");
    reRoute.id = item;
    reRoute.fromModule = "ViewApplicationCohort";
  };
  const ViewApplication = (dpiitNo) => {
    let reRoute = window.open(sample + "/view-StartupApplication", "_blank");
    reRoute.id = dpiitNo;
    reRoute.fromModule = "startUpApplications";
    // history.push({
    //   pathname: "/view-StartupApplication",
    //   state: dpiitNo
    //   // { data: item, prevPage: "startUpList" },
    // });
  };
  const redirectProfile = (dpiitNo) => {
    let reRoute = window.open(sample + "/startup-profile", "_blank");
    reRoute.id = dpiitNo;
    // history.push({
    //   pathname: "/startup-profile",
    //   state: dpiitNo,
    //   // state: { data: props.history.location.state, prevPage: "startUpDash" },
    // });
  };
  const createMentorMatchInitial = (cohortId) => {
    let params = {
      cohortAdminId: LoginUser.id,
      cohortId: cohortId,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "name",
        sortOrder: "ASC",
      },
    };
    getmatchTableList(params);
  };
  // useEffect(() => {
  //
  //   if (cohortMatchMakingList && cohortMatchMakingList.length > 0) {
  //     setCohortModalMentorData2(cohortMatchMakingList);
  //   }
  // }, [cohortMatchMakingList]);

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    let params = {
      requestedBy: "",
      status: selectedStatus,
      pageFilter: {
        currentPage: pageNumber - 1,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: filterNameValue == "select" ? "" : filterNameValue,
      searchKey: null,
      country: "",
      // id: formData?.name?.value == "select" ? null : formData?.name?.value, // optional
      state: formData.state == "select" ? null : formData?.state?.value, // optional
      industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
      function: formData.function == "select" ? "" : formData?.function?.value, // optional
      stage: formData.stage == "select" ? "" : formData?.stage?.value,
    };
    getMentorCohortApplicationList(params);
    // getStartupApplication(params);
  };
  const getCohortMentorFunction = (id) => {
    let params = {
      cohortId: id,
      mentorId: "",
      cohortAdminId: "",
      requestStatus: "ACCEPTED",
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: "",
      searchKey: "",
    };
    postMentorModuleCohort(params);
  };
  const getCohortStartupFunction = (id) => {
    let params = {
      cohortId: id,
      mentorId: "",
      cohortAdminId: "",
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: "",
      searchKey: "",
      requestStatus: "Accepted",
    };
    postMentorModuleStartupCohort(params);
  };
  // useEffect(() => {
  //
  //   if (cohortStartupData && cohortStartupData.length > 0)
  //     cohortStartupData.forEach((element) => {
  //
  //       setCohortModalMentorData((data) => [...data, element.startup]);
  //     });
  // }, [cohortStartupData]);
  // useEffect(() => {
  //
  //   if (cohortMentorData && cohortMentorData.length > 0)
  //     cohortMentorData.forEach((element) => {
  //
  //       setCohortModalMentorData((data) => [...data, element.mentor]);
  //     });
  // }, [cohortMentorData]);
  //   useEffect(() => {
  //     let params = {
  //       requestedBy: "",
  //     };
  //     getCountersStartUpList(params);
  //   }, []);
  //   useEffect(() => {
  //     setTableList(startUpApplication);
  //     let data = startUpApplication?.requestJson;
  //     setMentorShipReqData(data);
  //   }, [startUpApplication]);
  const getStartUpId = (string) => {
    const value = string.substring(string?.length - 6);
    return value;
  };

  const ViewProfile = (item, id) => {
    setSelectedRow(id);

    let reRoute = window.open(sample + `/mentor-profile/${item}`, "_blank");
    reRoute.id = item;
    //
    // history.push({
    //   pathname: `/mentor-profile/${item.email}`,
    //   state: { prevPage: "mentorPage",data:item },
    // });
  };
  useEffect(() => {
    window.scrollTo(0, 1);
  }, []);
  const getExcelDownload = () => {
    let url = history?.location?.state?.fromModule == "activityCohortDetailsStartup" ? DOWNLOAD_EXCEL_TOTAL_COHORT_STARTUPS : DOWNLOAD_EXCEL_TOTAL_COHORT_MENTORS;
    let fileName = history?.location?.state?.fromModule == "activityCohortDetailsStartup" ? 'TotalStartupsInCohort.xls' : 'TotalMentorInCohort.xls';
    api
      .GET(`${url}`, {responseType: "blob",})
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${fileName}`);
        document.body.appendChild(link);
        link.click();
      });
  };
  return (
    <>
      <div
        className={
          history?.location?.state?.fromModule ===
          "activityCohortDetailsStartup"
            ? "sameeentrediv startupandmentorsummary"
            : "sameeentrediv mentorengaeddataabc"
        }
      >
        {/* <div className="mentorlistmaindiv sameeentrediv startupandmentorsummary"> */}
        <div className="dashboard-main2" style={{ background: "none" }}>
          <div
            className="dashboard-bottom-btn4 topbackbtnmentorlist"
            style={{ background: "transparent", border: "none" }}
          >
            <div className="newuserTooltip">
              <MaterialButton
                className="topbackbtnactual top-btn"
                variant="contained"
                color="primary"
                onClick={() => {
                  if (LoginRole === "Mentor") {
                    if (
                      history?.location?.state?.fromModule !== undefined &&
                      history?.location?.state?.fromModule !== null &&
                      history?.location?.state?.fromModule ===
                        "cohortStartupRequest"
                    ) {
                      props.setSelectedMenu("cohortStartup");
                      history.push("/dashboard");
                    } else if (
                      history?.location?.state?.fromModule !== undefined &&
                      history?.location?.state?.fromModule !== null &&
                      history?.location?.state?.fromModule ===
                        "cohortMentorApplication"
                    ) {
                      props.setSelectedMenu("cohortApplicationMentor");
                      history.push("/dashboard");
                    } else if (
                      history?.location?.state?.fromModule !== undefined &&
                      history?.location?.state?.fromModule !== null &&
                      history?.location?.state?.fromModule ===
                        "cohortMentorRequest"
                    ) {
                      props.setSelectedMenu("cohortMentors");
                      history.push("/dashboard");
                    } else {
                      props.setSelectedMenu("adminMenu");
                      history.push("/dashboard");
                    }
                  } else {
                    if (
                      history?.location?.state?.fromModule ===
                        "activitySummary" ||
                      history?.location?.state?.fromModule ===
                        "activityCohortDetailsStartup" ||
                      history?.location?.state?.fromModule ===
                        "activityCohortDetailsMentor"
                    ) {
                      localStorage.setItem(
                        "activitySummary",
                        "activitySummary"
                      );

                      window.location.reload();
                      // cohortApplication
                    } else if (
                      history.location.state.fromModule ===
                      "cohortAdminApplication"
                    ) {
                      localStorage.setItem(
                        "cohortApplication",
                        "cohortApplication"
                      );

                      window.location.reload();
                      // cohortApplication
                    } else {
                      localStorage.setItem(
                        "mentorDashboardHome",
                        "mentorDashboardHome"
                      );
                      window.location.reload();
                    }
                  }
                }}
                style={{ background: "#3ac2d7" }}
              >
                {" "}
                Back
              </MaterialButton>
              <span
                className="tooltiptext tooltip-bottom"
                style={{
                  top: "69px",
                  width: "217px",
                  left: "71px",
                }}
              >
                {history?.location?.state?.fromModule ===
                "cohortMentorApplication"
                  ? "Click to Go Cohort Applications "
                  : history?.location?.state?.fromModule ===
                      "activitySummary" ||
                    history?.location?.state?.fromModule ===
                      "activityCohortDetailsStartup" ||
                    history?.location?.state?.fromModule ===
                      "activityCohortDetailsMentor"
                  ? "Click to Go Activity Summary"
                  : history?.location?.state?.fromModule ===
                    "cohortAdminApplication"
                  ? "Click to Go Cohort Applications"
                  : "Click to Go My Dashboard "}
              </span>
            </div>

            <Modal
              modalOpen={modalOpen}
              setModalOpen={setModalOpen}
              modalData={modalData}
            />
            {modalVisibility && (
              <CohortSummaryModal
                setModalVisibility={setModalVisibility}
                fromModule={fromModule}
                modalVisibility={modalVisibility}
                cohortId={cohortModalData}
                fromPage={"mentorships"}
              />
            )}
            {modalVisibility2 && (
              <MentorshipSummaryModal
                setModalVisibility={setModalVisibility2}
                modalVisibility={modalVisibility2}
                cohortId={cohortModalMentorData2}
              />
            )}
          </div>
          <div className="iconWith-heading iconheadingdata iconheadingdataupperdiv">
            <div style={{ width: "100%" ,marginLeft:"0.5rem"}}>
              <h3
                className="sub-heading fadeInDown wow"
                style={{ color: "#262838", fontWeight: 600, fontSize: "28px" }}
              >
                MAARG Portal by Startup India
              </h3>
              <h3 className="dashboard-sub-heading fadeInDown wow conditionheadingformb">
                ACTIVITY SUMMARY: TOTAL{" "}
                {history?.location?.state?.fromModule ===
                "activityCohortDetailsStartup"
                  ? "STARTUPS"
                  : "MENTORS"}{" "}
                IN A COHORT
              </h3>
            </div>
            <a onClick={() => getExcelDownload()}>
              <div className="newuserTooltip">
                <img
                  className="excelButton excelbuttonadmindash"
                  src={excelButton}
                  style={{ top: "2.4rem", width: "47%", left: "0rem" }}
                ></img>
                <span
                  className="tooltiptext   tooltip-bottom admincohort01"
                  style={{ left: "0.5rem", top: "5.75rem", width: "12vw" }}
                >
                  Download Excel Report
                </span>
              </div>
            </a>
            <div
              className="tooltipshow eyeIcon"
              // onClick={() => {
              //   html.style.overflow = "hidden";
              // }}
            >
              <div className="newuserTooltip">
                <img
                  className="iconbtn top-btn"
                  src={iconTooltip}
                  onClick={() => {
                    setModalIsOpenToTrue();
                    if (html.style.overflow == "auto") {
                      html.style.overflow = "hidden";
                    } else {
                      html.style.overflow = "auto";
                    }
                  }}
                  width={60}
                />{" "}
                <span
                  className="tooltiptext tooltip-bottom "
                  style={{ width: "130px", top: "50px", left: "20px" }}
                >
                  View Instructions
                </span>
              </div>
            </div>
            {isShown && (
              <div>
                <AnimeList
                  setModalIsOpenToTrue={setModalIsOpenToTrue}
                  Heading={Heading}
                  InstructionswithRole={InstructionswithRole}
                  SelectPage={SelectPage}
                />
              </div>
            )}
          </div>
        </div>
        <div className="col-md-11 display-center mobilementorsummary">
          <div className="admin-bottom-card row activitydetsailsac">
            <div
              className="mentorImageParent d-flex justify-content-end"
              style={{
                background: "none",
                border: "0px",
                borderRadius: "0px",
              }}
            >
              <img src={mentorIcon} className="sidebar-dashboard-icon2" />
            </div>
            <div className="dashboard-bottom-btn3 cohortButtonBelow">
              <p className="text-white">COHORTS</p>
            </div>
            <div class="w-20 newuserTooltip circleBorder maxtotalCount">
              {history?.location?.state?.pageCounter}
              {/* {maxTotalCount} */}
            </div>
            <div class="w-40 newuserTooltip activitySummaryText last15days">
              Total{" "}
              {history?.location?.state?.fromModule ===
              "activityCohortDetailsStartup"
                ? "Startups"
                : "Mentors"}{" "}
              in a Cohort
            </div>
            {/* <div class="w-20 newuserTooltip">
             X
            </div> */}
          </div>
          <div className="filter-row filter-row-common filterDivMentorapp">
            <div>
              <form className="formContainer">
                <div className="row desktopFilterRow">
                  <div className="filter-row filter-row-common filterDivMentorapp">
                    <div>
                      <form className="formContainer">
                        <div className="row desktopFilterRow">
                          <div
                            className="col-11 d-flex justify-content-between filterboxfixwidthformb2"
                            style={{ position: "relative", right: "0.3rem" }}
                          >
                            <div className="dropDownWidthFix36 newuserTooltip">
                              <Select
                                required={true}
                                id="cohortorgname"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                name="cohortorgname"
                                className="col-12 gendermentorinput"
                                styles={customStyles}
                                value={formData.cohortorgname}
                                onChange={(e) => {
                                  setFormData((user) => {
                                    return {
                                      ...user,
                                      cohortorgname:
                                        e.value == "select" ? null : e,
                                    };
                                  });
                                  setFilterCohortId(e.value);
                                }}
                                options={cohortnameList}
                                placeholder="Cohort Name"
                              />
                              <span
                                className="tooltiptext tooltip-bottom"
                                style={{
                                  left: "77px",
                                  top: "45px",
                                  width: "150px",
                                }}
                              >
                                Search Cohort Name
                              </span>
                            </div>
                            <div className="dropDownWidthFix36 newuserTooltip">
                              <Select
                                required={true}
                                id="cohortId"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                name="cohortId"
                                className="col-12 gendermentorinput"
                                styles={customStyles}
                                value={formData.cohortId}
                                onChange={(e) => {
                                  setFormData((user) => {
                                    return {
                                      ...user,
                                      cohortId: e.value == "select" ? null : e,
                                    };
                                  });
                                  setFilterCohortId(e.value);
                                }}
                                options={cohortnameId}
                                placeholder="Cohort ID"
                              />
                              <span
                                className="tooltiptext tooltip-bottom"
                                style={{
                                  left: "77px",
                                  top: "45px",
                                  width: "160px",
                                }}
                              >
                                Search Cohort ID
                              </span>
                            </div>
                            <div className="dropDownWidthFix36 newuserTooltip">
                              <Select
                                required={true}
                                id="Industry"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                name="industry"
                                className="col-12 gendermentorinput"
                                styles={customStyles}
                                value={formData.industry}
                                onChange={(e) => {
                                  setFormData((user) => {
                                    return {
                                      ...user,
                                      industry: e.value == "select" ? null : e,
                                    };
                                  });
                                  setFilterIndustry(e.value);
                                }}
                                options={getPredefineOptions?.industry_options}
                                placeholder="Industry"
                              />
                              <span
                                className="tooltiptext tooltip-bottom"
                                style={{
                                  left: "77px",
                                  top: "45px",
                                  width: "130px",
                                }}
                              >
                                Search Industry
                              </span>
                            </div>
                            <div className="dropDownWidthFix36 newuserTooltip">
                              <Select
                                required={true}
                                id="specialization"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                name="specialization"
                                className="col-12 gendermentorinput"
                                styles={customStyles}
                                value={formData.function}
                                onChange={(e) => {
                                  setFormData((user) => {
                                    return {
                                      ...user,
                                      function: e.value == "select" ? null : e,
                                    };
                                  });
                                  setFilterFunction(e.value);
                                }}
                                options={getPredefineOptions?._specialisation}
                                placeholder="Function"
                              />
                              <span
                                className="tooltiptext tooltip-bottom"
                                style={{
                                  left: "77px",
                                  top: "45px",
                                  width: "130px",
                                }}
                              >
                                Search Function
                              </span>
                            </div>

                            <div className="dropDownWidthFix36 newuserTooltip">
                              <Select
                                required={true}
                                id="stage"
                                // label="Gender*"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                name="stage"
                                className="col-12 gendermentorinput"
                                styles={customStyles}
                                value={formData.stage}
                                onChange={(e) => {
                                  setFormData((user) => {
                                    return {
                                      ...user,
                                      stage: e.value == "select" ? null : e,
                                    };
                                  });
                                  setFilterStage(e.value);
                                }}
                                options={
                                  getPredefineOptions?.stage_of_startup_options
                                }
                                placeholder="Stage"
                              />
                              <span
                                className="tooltiptext tooltip-bottom"
                                style={{
                                  left: "77px",
                                  top: "45px",
                                  width: "130px",
                                }}
                              >
                                Search Stage
                              </span>
                            </div>

                            {/* <div className="dropDownWidthFix36">
                      <Select
                        required={true}
                        id="state"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="state"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.state}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              state: e.value == "select" ? null : e,
                            };
                          });
                          setFilterState(e.value);
                        }}
                        options={newStateOptions}
                        placeholder="State"
                      />
                    </div> */}
                          </div>

                          <div className="col-1 goBtnDivPositionResponsive gotgobtntable5 newuserTooltip">
                            <Button
                              // style={{
                              //   background: "#277acc",
                              // }}
                              // onClick={handleClickOfFilter}
                              //   onClick={() => getStartupApplicationTable(selectedStatus)}
                              onClick={getTableDataStatus2}
                              text="GO"
                              className="top-btn goBtnResponsive"
                            ></Button>
                            <span
                              className="tooltiptext   tooltip-bottom"
                              style={{
                                left: "46px",
                                width: "126px",
                                height: "48px",
                                top: "42px",
                              }}
                            >
                              Click to Apply Filters
                            </span>
                            {/* <Button
                      icon={<img src={arrow} className="search-icon" />}
                      text=""
                      onClick={() => getMentorApplications(selectedStatus)}
                      className="green-btn filter-btn apply-admin-dashbtn newfilterBtnallmentor"
                    /> */}
                          </div>
                        </div>

                        {/* <div className="row mobileFilterRow">
                          <div className="col-md-1 filter-text">Filter by</div>
  <div className="dropDownWidthFix36 newuserTooltip">
                              <Select
                                required={true}
                                id="cohortorgname"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                name="cohortorgname"
                                className="col-12 gendermentorinput"
                                styles={customStyles}
                                value={formData.cohortorgname}
                                onChange={(e) => {
                                  setFormData((user) => {
                                    return {
                                      ...user,
                                      cohortorgname:
                                        e.value == "select" ? null : e,
                                    };
                                  });
                                  setFilterCohortId(e.value);
                                }}
                                options={cohortnameList}
                                placeholder="Cohort Name"
                              />
                              <span
                                className="tooltiptext tooltip-bottom"
                                style={{
                                  left: "77px",
                                  top: "45px",
                                  width: "150px",
                                }}
                              >
                                Search Cohort Name
                              </span>
                            </div>
                            <div className="dropDownWidthFix36 newuserTooltip">
                              <Select
                                required={true}
                                id="cohortId"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                name="cohortId"
                                className="col-12 gendermentorinput"
                                styles={customStyles}
                                value={formData.cohortId}
                                onChange={(e) => {
                                  setFormData((user) => {
                                    return {
                                      ...user,
                                      cohortId: e.value == "select" ? null : e,
                                    };
                                  });
                                  setFilterCohortId(e.value);
                                }}
                                options={cohortnameId}
                                placeholder="Cohort ID"
                              />
                              <span
                                className="tooltiptext tooltip-bottom"
                                style={{
                                  left: "77px",
                                  top: "45px",
                                  width: "160px",
                                }}
                              >
                                Search Cohort ID
                              </span>
                            </div>
                          <div className="user-type-dropdown col-2 select-box">
                            <Select
                              required={true}
                              id="Industry"
                              variant="outlined"
                              fullWidth
                              margin="normal"
                              name="industry"
                              className="col-12 gendermentorinput"
                              styles={customStyles}
                              value={formData.industry}
                              onChange={(e) => {
                                setFormData((user) => {
                                  return {
                                    ...user,
                                    industry: e.value == "select" ? null : e,
                                  };
                                });
                                setFilterIndustry(e.value);
                              }}
                              options={getPredefineOptions?.industry_options}
                              placeholder="Industry"
                            />
                          </div>
                          <div className="user-type-dropdown col-2 select-box">
                            <Select
                              required={true}
                              id="specialization"
                              variant="outlined"
                              fullWidth
                              margin="normal"
                              name="specialization"
                              className="col-12 gendermentorinput"
                              styles={customStyles}
                              value={formData.function}
                              onChange={(e) => {
                                setFormData((user) => {
                                  return {
                                    ...user,
                                    function: e.value == "select" ? null : e,
                                  };
                                });
                                setFilterFunction(e.value);
                              }}
                              options={getPredefineOptions?._specialisation}
                              placeholder="Function"
                            />
                          </div>

                          <div className="user-type-dropdown col-2 select-box">
                            <Select
                              required={true}
                              id="stage"
                              variant="outlined"
                              fullWidth
                              margin="normal"
                              name="stage"
                              className="col-12 gendermentorinput"
                              styles={customStyles}
                              value={formData.stage}
                              onChange={(e) => {
                                setFormData((user) => {
                                  return {
                                    ...user,
                                    stage: e.value == "select" ? null : e,
                                  };
                                });
                                setFilterStage(e.value);
                              }}
                              options={
                                getPredefineOptions?.stage_of_startup_options
                              }
                              placeholder="Stage"
                            />
                          </div>
                          <div className="user-type-dropdown col-2 select-box">
                            <Select
                              required={true}
                              id="country"
                              variant="outlined"
                              fullWidth
                              margin="normal"
                              name="country"
                              className="col-12 gendermentorinput"
                              styles={customStyles}
                              value={formData.country}
                              onChange={(e) => {
                                setFormData((user) => {
                                  return {
                                    ...user,
                                    country: e.value == "select" ? null : e,
                                  };
                                });

                                setFilterCountry(e.label);

                                if (e.label === "India") {
                                  setNewCountrySelect(true);
                                } else {
                                  setNewCountrySelect(false);
                                }
                              }}
                              options={newCountryOptions}
                              placeholder="Country"
                            />
                          </div>

                          <div className="user-type-dropdown col-2 select-box">
                            <Select
                              required={true}
                              id="state"
                              variant="outlined"
                              fullWidth
                              margin="normal"
                              name="state"
                              className="col-12 gendermentorinput"
                              styles={customStyles}
                              value={formData.state}
                              onChange={(e) => {
                                setFormData((user) => {
                                  return {
                                    ...user,
                                    state: e.value == "select" ? null : e,
                                  };
                                });
                                setFilterState(e.value);
                              }}
                              options={newStateOptions}
                              placeholder="State"
                            />
                          </div>
                          <div
                            className="col-md-1 apply-section"
                            style={{ color: "transparent" }}
                          >
                            <Button
                              className="green-btn filter-btn"
                              onClick={getTableDataStatus2}
                              text="GO"
                            />
                          </div>
                        </div> */}
                      </form>
                    </div>
                  </div>
                </div>

                <div className="row mobileFilterRow mobileFilterRow2nd">
                  <div className="col-md-1 filter-text">Filter by</div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="cohortorgname"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="cohortorgname"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.cohortorgname}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            cohortorgname: e.value == "select" ? null : e,
                          };
                        });
                        setFilterCohortId(e.value);
                      }}
                      options={cohortnameList}
                      placeholder="Cohort Name"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="cohortId"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="cohortId"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.cohortId}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            cohortId: e.value == "select" ? null : e,
                          };
                        });
                        setFilterCohortId(e.value);
                      }}
                      options={cohortnameId}
                      placeholder="Cohort ID"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="Industry"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="industry"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.industry}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            industry: e.value == "select" ? null : e,
                          };
                        });
                        setFilterIndustry(e.value);
                      }}
                      options={getPredefineOptions?.industry_options}
                      placeholder="Industry"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="specialization"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="specialization"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.function}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            function: e.value == "select" ? null : e,
                          };
                        });
                        setFilterFunction(e.value);
                      }}
                      options={getPredefineOptions?._specialisation}
                      placeholder="Function"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="stage"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="stage"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.stage}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            stage: e.value == "select" ? null : e,
                          };
                        });
                        setFilterStage(e.value);
                      }}
                      options={getPredefineOptions?.stage_of_startup_options}
                      placeholder="Stage"
                    />
                  </div>
                  {/* <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="country"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="country"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.country}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            country: e.value == "select" ? null : e,
                          };
                        });

                        setFilterCountry(e.label);

                        if (e.label === "India") {
                          setNewCountrySelect(true);
                        } else {
                          setNewCountrySelect(false);
                        }
                        setNewStateOptions("");
                      }}
                      options={newCountryOptions}
                      placeholder="Country"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="state"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="state"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.state}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            state: e.value == "select" ? null : e,
                          };
                        });
                        setFilterState(e.value);
                      }}
                      options={newStateOptions}
                      placeholder="State"
                    />
                  </div> */}
                  <div
                    className="col-md-1 apply-section"
                    style={{ color: "transparent" }}
                  >
                    <Button
                      className="green-btn filter-btn"
                      onClick={getTableDataStatus2}
                      text="GO"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="totalTableCount">
            Total Cohort Programs : {getTableDataPaginate?.totalElements} &lt;{" "}
            {getTableDataPaginate?.currentPage} of{" "}
            {getTableDataPaginate?.numPages} &gt;{" "}
          </div>
          {/* {startUpApplication && startUpApplication?.length > 0 ? ( */}
          {getTableData && getTableData?.length > 0 ? (
            <div>
              <div className="table-container mt-2">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th
                        style={{ verticalAlign: "middle" }}
                        className="fixColumbnWidth4"
                      >
                        {" "}
                        <div>NO.</div>
                      </th>
                      <th
                        style={{ verticalAlign: "middle" }}
                        className="fixColumbnWidth"
                        colspan="2"
                      >
                        <div>COHORT DETAILS</div>
                      </th>
                      <th
                        style={{
                          maxWidth: "7rem",
                          fontSize: "15.3px",
                          verticalAlign: "middle",
                        }}
                      >
                        <div>COHORT ID</div>
                      </th>
                      <th
                        className="fixColumbnWidth7 headingWidthFixProgram"
                        style={{ verticalAlign: "middle" }}
                      >
                        <div>
                          {history?.location?.state?.fromModule ===
                          "activityCohortDetailsStartup"
                            ? "STARTUPS"
                            : "MENTORS"}{" "}
                          ENGAGED
                        </div>
                      </th>
                    </tr>
                  </thead>
                  {getTableData.map((item, index) => (
                    <tbody>
                      <tr
                        className={
                          item.id === selectedRow
                            ? "purpleBackground newtrpaddingonmblview"
                            : "newtrpaddingonmblview"
                        }
                        key={index}
                      >
                        <td style={{ verticalAlign: "middle" }}>
                          {getTableDataPaginate.currentPage === 1 ? (
                            <td>
                              {" "}
                              <div>{index + 1}</div>
                            </td>
                          ) : (
                            <td>
                              <div>
                                {index +
                                  1 +
                                  10 * (getTableDataPaginate.currentPage - 1)}
                              </div>
                            </td>
                          )}
                        </td>
                        <td
                          className="activuti-td001 accountyz"
                          style={
                            {
                              // display: "flex",
                              // justifyContent: "center",
                            }
                          }
                        >
                          <div
                            className="newuserTooltip"
                            style={{
                              width: "100px",
                              height: "100px",
                              maxWidth: "none",
                              objectFit: "contain",
                            }}
                          >
                            <img
                              onClick={
                                () => {
                                  let reRoute = window.open(
                                    sample + `/cohort-programs/all/${item?.id}`,
                                    "_blank"
                                  );
                                }
                                // history.push(`/cohort-programs/all/${item?.cohortID}`)
                              }
                              src={
                                item.uploadBanner === null
                                  ? hashImage
                                  : item.uploadBanner
                              }
                              className="sidebar-dashboard-icon2"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                cursor: "pointer",
                                position: "relative",
                                // top: "1rem",
                              }}
                            />
                            <span
                              className="tooltiptext tooltip-bottom "
                              style={{
                                left: "32px",
                                top: "100px",
                                width: "175px",
                              }}
                            >
                              {item.applicationStatus === "VERIFIED"
                                ? "View Cohort Details"
                                : "Cohort Preview"}
                            </span>
                            <div className="activity-001">
                              {item?.program_name?.length > 20 ? (
                                <div className="tooltipicon">
                                  {item?.program_name.substring(0, 20)}
                                  <svg
                                    style={{
                                      position: "relative",
                                      top: "0.1rem",
                                      cursor: "pointer",
                                    }}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    fill="currentColor"
                                    class="bi bi-three-dots"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                  </svg>
                                  <span className="tooltiptext7">
                                    <h5 style={{ color: "#fff" }}>
                                      Program Name
                                    </h5>
                                    {item.program_name}
                                  </span>
                                </div>
                              ) : (
                                item?.program_name
                              )}
                              {/* <p> {item.organization_name}</p> */}
                              {item?.organization_name.length > 20 ? (
                                <div className="tooltipicon">
                                  {item?.organization_name.substring(0, 20)}
                                  <svg
                                    style={{
                                      position: "relative",
                                      top: "0.1rem",
                                      cursor: "pointer",
                                    }}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    fill="currentColor"
                                    class="bi bi-three-dots"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                  </svg>
                                  <span className="tooltiptext7">
                                    <h5 style={{ color: "#fff" }}>
                                      Organization Name
                                    </h5>
                                    {item?.organization_name}
                                  </span>
                                </div>
                              ) : (
                                item?.organization_name
                              )}
                              <p>
                                {" "}
                                Start Date:
                                {moment(item?.cohort_date).format("DD/MM/YYYY")}
                              </p>
                              <p> Duration: {item.program_duration}</p>
                              <div
                                className="newuserTooltip"
                                style={{
                                  cursor: "pointer",
                                  alignItems: "end",
                                  justifyContent: "end",

                                  minWidth: "40px",
                                  display: "flex",
                                }}
                              >
                                <img
                                  src={profile}
                                  width={40}
                                  onClick={() => {
                                    let reRoute = window.open(
                                      sample +
                                        `/cohort-programs/all/${item?.id}`,
                                      "_blank"
                                    );
                                  }}
                                />
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    left: "-3px",
                                    top: "102px",
                                    width: "184px",
                                  }}
                                >
                                  {item.applicationStatus === "VERIFIED"
                                    ? "View Cohort Details"
                                    : "Cohort Preview"}
                                </span>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td
                          className="activity-0001"
                          style={{ minWidth: "31.9rem", maxWidth: "32rem" }}
                        >
                          <div
                            style={{
                              flexDirection: "row",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                cursor: "pointer",
                                alignItems: "center",
                                display: "flex",
                                minWidth: "200px",
                              }}
                            >
                              {item.program_name}
                              <br></br>
                              {item.organization_name}
                              <br></br>
                              Start Date:{" "}
                              {moment(item?.cohort_date).format("DD/MM/YYYY")}
                              <br></br>
                              Duration: {item.program_duration}
                              <br></br>
                            </div>
                            <div
                              className="newuserTooltip"
                              style={{
                                cursor: "pointer",
                                alignItems: "end",
                                justifyContent: "center",

                                minWidth: "40px",
                                display: "flex",
                              }}
                            >
                              <img
                                src={profile}
                                onClick={() => {
                                  let reRoute = window.open(
                                    sample + `/cohort-programs/all/${item?.id}`,
                                    "_blank"
                                  );
                                }}
                              />
                              <span
                                className="tooltiptext tooltip-bottom "
                                style={{
                                  left: "-3px",
                                  top: "102px",
                                  width: "184px",
                                }}
                              >
                                {item.applicationStatus === "VERIFIED"
                                  ? "View Cohort Details"
                                  : "Cohort Preview"}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td
                          className="togglediv"
                          style={{
                            verticalAlign: "middle",
                            minWidth: "17.9rem",
                            maxWidth: "18rem",
                          }}
                        >
                          <div className="newuserTooltip">
                            <a
                              onClick={() => {
                                ViewApplicationCohort(item.id);
                              }}
                              // href="#"
                              className="color-green"
                            >
                              {" "}
                              {item.cohortId !== null &&
                                item.cohortId !== "" &&
                                "C" +
                                  item.cohortId.substring(
                                    item.cohortId.length - 6
                                  )}
                            </a>
                            <span
                              className="tooltiptext mentoricon tooltip-bottom"
                              style={{ width: "12.5vw" }}
                            >
                              View Cohort Application
                            </span>
                          </div>
                          <div className="mt-2">
                            {moment(item?.date_applied).format("DD/MM/YYYY")}
                          </div>
                        </td>
                        <td
                          className="togglediv2"
                          style={{
                            verticalAlign: "middle",
                            minWidth: "17.9rem",
                            maxWidth: "18rem",
                          }}
                        >
                          <div>
                            <a
                              onClick={() => {
                                ViewApplicationCohort(item.id);
                              }}
                              // href="#"
                              className="color-green"
                            >
                              {" "}
                              {item.cohortId !== null &&
                                item.cohortId !== "" &&
                                "C" +
                                  item.cohortId.substring(
                                    item.cohortId.length - 6
                                  )}
                            </a>
                            <br></br>

                            {moment(item?.date_applied).format("DD/MM/YYYY")}
                          </div>
                        </td>
                        {history?.location?.state?.fromModule ===
                        "activityCohortDetailsStartup" ? (
                          <td
                            style={{ position: "relative" }}
                            className="extraheighticon"
                          >
                            <div className="IconWithData">
                              <div className="propertiescommon">
                                {item.startupsEngaged}
                              </div>
                              {item?.startupsEngaged > 0 ? (
                                <div
                                  className="d-flex justify-content-end newuserTooltip cohort-programIcons"
                                  onClick={() => {
                                    setCohortModalMentorData((data) => []);
                                    setModalVisibility(true);
                                    setFromModule("Startup");
                                    setCohortModalData(item.cohortId);
                                  }}
                                >
                                  <img
                                    style={{ height: "40px" }}
                                    src={mentorshipIcon3}
                                  />
                                  <span
                                    className="tooltiptext tooltip-bottom "
                                    style={{
                                      left: "-21px",
                                      top: "6.85rem",
                                      width: "12.5vw",
                                    }}
                                  >
                                    View Startup Engaged
                                  </span>
                                </div>
                              ) : (
                                ""
                              )}{" "}
                            </div>
                          </td>
                        ) : (
                          <td
                            style={{ position: "relative" }}
                            className="extraheighticon"
                          >
                            <div className="IconWithData">
                              <div className="propertiescommon">
                                {item?.mentorsEngaged}
                              </div>
                              {item?.mentorsEngaged > 0 ? (
                                <div
                                  className="d-flex justify-content-end newuserTooltip cohort-programIcons"
                                  onClick={() => {
                                    setCohortModalMentorData((data) => []);
                                    setModalVisibility(true);
                                    setFromModule("Mentor");
                                    setCohortModalData(item.cohortId);
                                  }}
                                >
                                  <img
                                    src={mentorshipIcon4}
                                    height={40}
                                    width={40}
                                  />
                                  <span
                                    className="tooltiptext tooltip-bottom "
                                    style={{
                                      left: "-20px",
                                      top: "110px",
                                      width: "12.5vw",
                                    }}
                                  >
                                    View Mentors Engaged
                                  </span>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    </tbody>
                  ))}
                </table>
                <div className="pagination-box">
                  {getTableDataPaginate !== undefined && (
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={10}
                      //   totalItemsCount={
                      //     startUpApplicationPagineate?.totalElements
                      //   }
                      totalItemsCount={getTableDataPaginate.totalElements}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange.bind(this)}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="no-records">No Records Found</div>
          )}
          {/* ) : (
            <div className="no-records">No Records Found</div>
          )} */}
          {/* <div
            className="dashboard-bottom-btn top-btn dashboardbelowBtn"
            style={{ margin: "auto" }}
            onClick={() => {
              history.push({
                state: {
                  fromModule: "startUpApplications",
                },
              });
              localStorage.setItem("allStartupList", "allStartupList");
              window.location.reload();
            }}
          >
            <p style={{ cursor: "pointer" }} className="text-white3">
              VIEW STARTUP LIST
            </p>
          </div> */}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    startUpApplication: state.StartUpReducer.StartUpApplications.data,
    startUpApplicationPagineate:
      state.StartUpReducer.StartUpApplications.paginate,
    getCounterStartUp: state.StartUpReducer.getCountersStartUpList.data,
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
    getTableData: state.MentorReducer.getCohortMentorList.data,
    getTableDataPaginate: state.MentorReducer.getCohortMentorList.paginate,
    cohortMentorData: state.MentorReducer.getCohortMentorModuleList.data,
    cohortStartupData:
      state.MentorReducer.getStartupCohortMentorModuleList.data,
    cohortMatchMakingList: state.MentorReducer.getMatchMakingResult.data,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
  };
};
export default connect(mapStateToProps, {
  //   getStartupApplication,
  //   getCountersStartUpList,
  postMentorModuleCohort,
  postMentorModuleStartupCohort,
  getPredefineOptionsList,
  getStepperTooltipData,
  getNamesList,
  getMentorCohortApplicationList,
  getmatchTableList,
})(withRouter(ActivityCohortTotal));
